import { useGetEventBySlugQuery } from "@ac-expo/api";
import { useEventPasswordProtection } from "@ac-expo/hooks";
import { useToast } from "@ac-expo/ui-components";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import EventDetail from "./EventDetail";
import { EventPasswordForm } from "./EventPasswordForm";
import { getErrorMessage } from "@ac-expo/utils";

interface ProtectedEventDetailProps {
  eventSlug: string;
}

export const ProtectedEventDetail = observer(
  ({ eventSlug }: ProtectedEventDetailProps) => {
    const { data: event, isLoading } = useGetEventBySlugQuery(eventSlug);
    const { toast } = useToast();
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
      setIsMounted(true);
    }, []);

    const { shouldAskPassword, verifyPassword, isVerifyingPassword } =
      useEventPasswordProtection({
        eventId: event?.id,
        eventSlug,
        hasPassword: event?.hasPassword,
        storage: isMounted ? window.localStorage : undefined,
      });

    const handlePasswordSubmit = async (password: string) => {
      try {
        await verifyPassword(password);
      } catch (error) {
        toast({
          title: "Erreur",
          description: getErrorMessage(error, "Mot de passe incorrect"),
        });
      }
    };

    if (isLoading || !event || !isMounted) {
      return <EventDetail eventSlug={eventSlug} />;
    }

    if (shouldAskPassword) {
      return (
        <EventPasswordForm
          onPasswordSubmit={handlePasswordSubmit}
          isSubmitting={isVerifyingPassword}
        />
      );
    }

    return <EventDetail eventSlug={eventSlug} />;
  }
);

export default ProtectedEventDetail;
